module.exports = __webpack_public_path__ + "img/10000-followers.bada0ed.png";